import {log} from "../util/logger";

const faqModule = faqModule || (function (w, d, $) {
  'use strict';

  var jqXHR,
    jqFaqItems = $('#faqItems'),
    jqFaqSearchform = $('#faqSearchform'),
    jqLoader = $('<div id="faqLoader" class="faq__loader"></div>'),
    processData,
    module;

  function bindEvents() {
    // FAQ search form
    jqFaqSearchform.on('submit', function (event) {
      var input = $(this).find('[name=s]');
      event.preventDefault();
      if (input.val().length) {
        input.autocomplete('search');
      } else {
        fetchFaqItems().done(processData);
      }
    }).find('[name=s]').each(function () {
      $(this).autocomplete({
        source: function (request, response) {
          fetchFaqItems(request.term).done(processData);
        }
      });
    });

    $('.js-clearFaqSearch', jqFaqSearchform).on('click', function () {
      $('[name=s]', jqFaqSearchform).val('');
      jqFaqSearchform.trigger('submit');
    });
  }

  /**
   * Return an Ajax request with search results
   */
  function fetchFaqItems(term) {
    if (jqXHR)
      jqXHR.abort();

    var submit = jqFaqSearchform.find('[type=submit]'),
      params = {
        action: 'faq-search',
        path: d.location.pathname,
      };

    if (term) {
      $('.js-clearFaqSearch', jqFaqSearchform).show();
      module.isSearching = true;
      params.s = term;
    } else {
      $('.js-clearFaqSearch', jqFaqSearchform).hide();
      module.isSearching = false;
    }

    // Show loading information
    jqLoader.appendTo(jqFaqItems).show();
    submit.find('.loader').removeClass('off').next().css('visibility', 'hidden');
    // Perform the search request
    jqXHR = $.ajax({
      url: jqFaqSearchform.data('formUrl'),
      method: 'GET',
      data: params
    });
    jqXHR.always(function () {
      // Hide loading information
      jqLoader.hide();
      setTimeout(function () {
        submit.find('.loader').addClass('off').next().css('visibility', 'visible');
      }, 800);
    });

    return jqXHR;
  }

  /**
   * Return markup for the category items
   */
  function getCategoriesMarkup(categories) {
    if (!categories || !categories.length)
      return;

    var html = '',
      shortName = '',
      longName = '',
      patternShortName = /\[(.+)\]/,
      patternLongName = /(.*)\[/,
      i = categories.length - 1;

    html += '<div class="faq-tabs">';
    html += '<div class="faq-tabs__top">';
    html += '<ol class="faq-tabsHeader">';
    do {
      html += '<li class="faq-tab" data-entity-id="' + categories[i].id + '">';
      html += '<a href="#faq-tab-' + i + '">';
      longName = shortName = patternLongName.test(categories[i].name) ? patternLongName.exec(categories[i].name)[1] : categories[i].name;
      if (patternShortName.test(categories[i].name)) {
        shortName = patternShortName.exec(categories[i].name)[1];
      } else {
        shortName = longName;
      }
      html += '<span class="d-inline d-md-none">';
      html += shortName;
      html += '</span>';
      html += '<span class="d-none d-md-inline">';
      html += longName;
      html += '</span>';
      if (module.isSearching) {
        html += '<div class="faq-tabNumItems">';
        html += categories[i].posts ? categories[i].posts.length : 0;
        html += ' resultat';
        html += '</div>';
      }
      html += '</a>';
      html += '</li>';
    } while (i--);
    html += '</ol>';
    html += '</div>';
    html += '<div class="faq-tabsSeparator"></div>';

    i = categories.length - 1;
    html += '<div class="faq-tabs__content">';
    do {
      html += '<div id="faq-tab-' + i + '" class="faq-tabContent">';
      if (categories[i].posts) {
        html += getPostsMarkup(categories[i].posts);
      } else {
        html += getStatusMessageMarkup('Det gick inte att hitta några relevanta inlägg i denna kategori.');
      }
      html += '</div>';
    } while (i--);
    html += '</div>';
    html += '</div>';

    return html;
  }

  function getStatusMessageMarkup(message, className) {
    if (!className) {
      className = 'notice';
    }

    return '<div class="status ' + className + '"><em>' + message + '</em></div>';
  }

  /**
   * Return markup for the post items
   * @param items
   * @returns {string}
   */
  function getPostsMarkup(items) {
    if (!items || !items.length)
      return;

    let html = '<ol class="mbp-accordion faq-accordion">',
      i = items.length - 1;
    do {
      html += '<li class="accordion-list-item ' + (i % 2 === 0 ? 'even' : 'odd') + '" data-entity-id="' + items[i].value + '" data-entity-name="' + items[i].name + '" data-entity-category="' + items[i].category + '">';
      html += '<a href="#" class="accordion-heading"><span class="iconmoon iconmoon-close"></span><span class="label">';
      html += items[i].label;
      html += '</span></a>';
      html += '<div class="accordion-content">';
      html += items[i].desc;
      html += '</div>';
      html += '</li>';
    } while (i--);
    html += '</ol>';

    return html;
  }

  /**
   * Create the accordion menu
   * @param items
   * @returns {boolean}
   */
  function runAccordion(items) {
    const jqAccordions = $('.mbp-accordion', jqFaqItems);

    if (jqAccordions.length < 1) {
      return false;
    }

    jqAccordions.accordion({
      autoHeight: false,
      active: false,
      collapsible: true,
      heightStyle: "content",
      animate: 300,
      icons: false
    });

    $('a[href*="?faq="]', jqAccordions).on('click', function (e) {
      var href = $(this).attr('href'),
        pattern = /\?faq=([^&]+)/;
      if (pattern.test(href)) {
        var matches = pattern.exec(href);
        if (faqModule.isSearching) {
          // Clear any search before navigating to the selected item
          fetchFaqItems().done(function (data) {
            processData(data);
            showFAQItem(matches[1]);
          });
        } else {
          showFAQItem(matches[1]);
        }
      }
      e.preventDefault();
    });
  }

  /**
   * Create the tab menu
   * @param items
   * @returns {boolean}
   */
  function runTabs(items) {
    const jqTabs = $('.faq-tabs', jqFaqItems);

    if (jqTabs.length < 1) {
      return false;
    }

    jqTabs.tabs({
      collapsible: false,
      heightStyle: "content"
    });

    if (items && items.length) {
      var i = items.length - 1;
      do {
        if (items[i].posts) {
          let tabIndex = items.length - i - 1;
          jqTabs.tabs('option', 'active', tabIndex);
          break;
        }
      } while (i--);
    }
  }

  /**
   * Remove any existing jQuery UI data
   */
  function cleanupUI() {
    let jqTabs = $('.faq-tabs', jqFaqItems);
    let jqAccordions = $('.faq-accordion', jqFaqItems);
    if (jqTabs.data('ui-tabs'))
      jqTabs.tabs('destroy');
    if (jqAccordions.data('ui-accordion'))
      jqAccordions.accordion('destroy');

  }

  /**
   *  Navigate to any existing FAQ item
   * @param searchstring
   * @returns {boolean}
   */
  function showFAQItem(searchstring) {
    var jqTabs = $('.faq-tabs', jqFaqItems);
    var jqAccordions = $('.faq-accordion', jqFaqItems);
    var jqResult = $('li[data-entity-name="' + searchstring + '"]:first', jqAccordions);
    if (jqResult.length) {
      var category = jqResult.data('entityCategory');
      if (category) {
        var tabIndex = $('li[data-entity-id="' + category + '"]:first', jqTabs).index();
        jqTabs.tabs('option', 'active', tabIndex);
        $('.faq-accordion', $('.faq-tabContent', jqTabs).eq(tabIndex)).accordion('option', 'active', jqResult.index());

        return true;
      }
    }
    alert('Det gick tyvärr inte att hitta någon matchande artikel.');

    return false;
  }

  /**
   * Handle available data from the search request
   */
  processData = function (data) {
    if (!data || !data.categories)
      return;

    cleanupUI();
    if (data.success) {
      jqFaqItems.html(getCategoriesMarkup(data.categories));
      runTabs(data.categories);
      runAccordion(data.categories);
      // Do an animated scroll to the search result
      $('html, body').animate({
        scrollTop: jqFaqItems.offset().top
      }, 500);
    } else {
      jqFaqItems.html(getStatusMessageMarkup('Det gick tyvärr inte att hitta någon mer information. Prova att ändra din sökning.'));
    }
  };
  module = {
    isSearching: false,
    init: function () {
      log('FAQ init');
      bindEvents();
      fetchFaqItems()
        .done(function (data) {
          if (data.success) {
            jqFaqItems.html(getCategoriesMarkup(data.categories));
            runTabs(data.categories);
            runAccordion(data.categories);
          } else {
            jqFaqItems.html(getStatusMessageMarkup('Det gick tyvärr inte att hitta någon information just nu. Välkommen tillbaka lite senare!'));
          }
        })
        .fail(function () {
          jqFaqItems.html(getStatusMessageMarkup('Ett tillfälligt fel uppstod när informationen skulle hämtas. Välkommen tillbaka om en liten stund!', 'error'));
        });
    }
  };
  return module;

})(window, document, jQuery);


faqModule.init();
